import React from 'react';
import { observer } from 'mobx-react';
import IssuerInvestmentVM from './IssuerInvestmentVM';
import { Neo, Routing } from '@singularsystems/neo-react';
import NewIssuerInvestmentCommand from '../../Models/IssuerInvestments/Commands/NewIssuerInvestmentCommand';
import InvestorInvestmentLookup from '../../Models/InvestorInvestments/Lookups/InvestorInvestmentLookup';
import { Misc, Model, NumberUtils } from '@singularsystems/neo-core';

interface INewIssuerInvestmentProps {
    issuerInvestmentVM: IssuerInvestmentVM;
    viewParam: Routing.IViewParameter;
}

@observer
export default class NewIssuerInvestmentModal extends React.Component<INewIssuerInvestmentProps> {

    constructor(props: INewIssuerInvestmentProps) {
        super(props);
    }

    public render() {
        const viewModel = this.props.issuerInvestmentVM;

        return (
            <Neo.Modal
                title="New Investment"
                bindModel={viewModel.meta.newIssuerInvestment}
                acceptButton={{ onClick: () => viewModel.createNewInvestment() }}
                onClose={() => this.props.viewParam.reset()}>
                {(investment: NewIssuerInvestmentCommand) => (
                    <div>
                        <Neo.FormGroupInline bindContext={investment.meta.issuerId}>
                            <Neo.AutoCompleteDropDown
                                bind={investment.meta.issuerId}
                                bindDisplay={investment.lookup.meta.issuerName}
                                itemSource={viewModel.issuerApiClient.getIssuerLookups}
                                onItemSelected={issuer => investment.setIssuer(issuer)} />
                        </Neo.FormGroupInline>
                        
                        <Neo.FormGroupInline
                            bind={investment.meta.entityId}
                            select={{ itemSource: viewModel.dataCache.entities, onItemSelected: item => investment.lookup.hasVestingTrust = item?.hasVestingTrust ?? false }} />

                        {investment.lookup.hasVestingTrust &&
                            <Neo.FormGroupInline bindContext={investment.meta.investorInvestmentId}>
                                <Neo.AutoCompleteDropDown
                                    bind={investment.meta.investorInvestmentId}
                                    bindDisplay={investment.lookup.meta.investorInvestmentName}
                                    itemSource={(st) => viewModel.investorInvestmentApiClient.getInvestorInvestmentLookups(st, false, null)}
                                    option={(item: Model.PlainObject<InvestorInvestmentLookup>) => <>
                                        <div style={{ flexBasis: 100 }}>{item.investorName}</div>
                                        <div style={{ flexBasis: 100 }}>{item.investorInvestmentId}</div>
                                        <div style={{ flexBasis: 100 }}>
                                            {NumberUtils.format(item.currentBalance, Misc.NumberFormat.CurrencyNoDecimals, "R")}
                                        </div>
                                    </>
                                    }
                                />
                            </Neo.FormGroupInline>}
                    </div>
                )}
            </Neo.Modal>
        );
    }
}